export const replaceCPF = (cpf: string): string => {
  return cpf?.replaceAll('.', '').replaceAll('-', '')
}
